import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import './AccountOrderPages.css';

const REASONS = [
  { id: 'defect', name: '商品瑕疵', sub: '掉漆 / 變形 / 缺件' },
  { id: 'wrong',  name: '寄錯規格', sub: '重量、Tip 型式不符訂單' },
  { id: 'change', name: '改變主意', sub: '7 天鑑賞期內無理由退貨' },
  { id: 'broken', name: '運送破損', sub: '外包裝完整但內部損壞' },
  { id: 'other',  name: '其他原因', sub: '請於下方說明欄詳述' },
];

function ReturnRefundPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [reason, setReason] = useState('defect');
  const [method, setMethod] = useState('pickup');

  return (
    <main className="v3-wr">
      <div className="v3-wr-card">
        <h1>申請退換貨</h1>
        <p className="desc">7 天鑑賞期內可申請。提交後 1–2 工作日審核，通過後安排取件 / 退款。</p>

        <div className="prod-row">
          <div className="pic"><svg viewBox="0 0 200 600"><use href="#dart-full" /></svg></div>
          <div>
            <b>TARGET SERENO G2 23g 鈴木徹</b>
            <small>NT$1,200 · 訂單 #{id === '1' ? 'MD-251108-0428' : id}</small>
          </div>
        </div>

        <div className="v3-wr-field" style={{ marginBottom: 8 }}>
          <label>退換原因</label>
        </div>
        <div className="v3-rr-reasons">
          {REASONS.map(r => (
            <div
              key={r.id}
              className={`v3-rr-reason${reason === r.id ? ' on' : ''}`}
              onClick={() => setReason(r.id)}
            >
              <b>{r.name}</b>
              <small>{r.sub}</small>
            </div>
          ))}
        </div>

        <div className="v3-wr-field" style={{ marginBottom: 8 }}>
          <label>取件方式</label>
        </div>
        <div className="v3-rr-method-row">
          <div
            className={`v3-rr-method${method === 'pickup' ? ' on' : ''}`}
            onClick={() => setMethod('pickup')}
          >
            <b>宅配取件</b>
            <small>黑貓上門收件 · 免運費</small>
          </div>
          <div
            className={`v3-rr-method${method === 'cvs' ? ' on' : ''}`}
            onClick={() => setMethod('cvs')}
          >
            <b>超商寄回</b>
            <small>7-11 / 全家 · 加 NT$60 由 MICHIDART 支付</small>
          </div>
        </div>

        <div className="v3-wr-field">
          <label>詳細說明</label>
          <textarea placeholder="請描述問題狀況，例：標身末端有明顯掉漆，可能是運送過程碰撞造成…" maxLength={300} />
        </div>

        <div className="v3-wr-upload">
          <b>＋ 上傳問題照片 (建議 3 張以上)</b>
          <small>瑕疵商品需附照片證據 · 各 ≤ 10MB</small>
        </div>

        <div className="v3-wr-actions">
          <button className="back" onClick={() => navigate(`/account/orders/${id}`)}>取消</button>
          <button className="primary" onClick={() => navigate(`/account/orders/${id}`)}>
            送出申請 →
          </button>
        </div>
      </div>
    </main>
  );
}

export default ReturnRefundPage;
